import AntButton from 'components/Common/AntButton';
import FormInput from 'components/Common/FormInput';
import FormSelect from 'components/Common/FormSelect';
import React from 'react';
import { useForm } from 'react-hook-form';
import fa from 'locales/fa.json';
import request from 'services/request';
import { SendPublicQuestionUrl } from 'services/routes';
import { message } from 'antd';
import { SkillsType } from 'types/course.type';
import { useSelector } from 'react-redux';

const SendQuestion: React.FC<{ skills: SkillsType[] }> = ({ skills }) => {
  const { handleSubmit, formState, control, reset } = useForm();
  const user = useSelector((state) => state.account.user);

  const onSubmit = async (data): Promise<void> => {
    if (user) {
      const res: any = await request.post(SendPublicQuestionUrl(), data); // eslint-disable-line
      if (res.ok) {
        message.success(res.data.message);
        reset();
      }
    } else
      message.warn('برای پرسیدن سوال عمومی لازم است ابتدا وارد حساب کاربری خود شوید');
  };
  return (
    <>
      <div className="text-indigo90 font-bold text-[22px] mb-[20px]">ارسال پرسش</div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <FormSelect
          control={control}
          name="category_id"
          placeholder="دسته بندی"
          rules={{ required: true }}
          options={skills?.map((skill) => ({ value: skill.id, label: skill.name }))}
        />
        <FormInput
          control={control}
          name="content"
          rtl
          textArea
          className="my-[20px] toRight"
          rules={{ required: true }}
          title="متن پرسش"
        />

        <AntButton htmlType="submit" className="w-full" loading={formState.isSubmitting}>
          {fa.global.send}
        </AntButton>
      </form>
    </>
  );
};

export default SendQuestion;
